module.exports = __webpack_public_path__ + "img/Hawaii.0f377a51.svg";